import {h, Component} from 'preact'
import CategorySelector, {ParentCategory, Group, isGroup} from '../category-selector/CategorySelector'
import {isChangeEvent} from '../../libs/typeGuards'


interface Props {
  onUpdate: (value: undefined | number) => void,
  categories: Array<ParentCategory | Group>,
  forum_id: number | null,
  error?: string,
  isKnowledgeBaseEnabled: boolean,
  isGroupsEnabled: boolean
}

interface State {
  publishIn: 'knowledgeBase' | 'community' | 'groups'
}

function hasCategoryWithId(categoryId: number) {
  return (parent: ParentCategory | Group) => {
    if (isGroup(parent)) {
      return parent.groupId === categoryId
    }
    return parent.categories && parent.categories.map(c => c.categoryId).includes(categoryId)
  }
}

export default class CategorySelect extends Component<Props, State> {
  constructor(props: Props) {
    super()

    let publishIn: State['publishIn'] = 'community'

    if (props.forum_id) {
      const grouppedCategories = this.groupCategories(props)
      if (grouppedCategories.groups.some(hasCategoryWithId(props.forum_id))) {
        publishIn = 'groups'
      } else if (grouppedCategories.knowledgeBase.some(hasCategoryWithId(props.forum_id))) {
        publishIn = 'knowledgeBase'
      }
    }

    this.state = {publishIn}

    this.handleRadioInputChange = this.handleRadioInputChange.bind(this)
  }

  handleRadioInputChange(event: Event) {
    if (!isChangeEvent(event)) return
    const value = event.target.value
    if (value === 'groups' || value === 'knowledgeBase' || value === 'community') {
      this.setState({publishIn: value})
    }
    this.props.onUpdate(undefined)
  }

  groupCategories(props: Props) {
    const {
      categories,
      isKnowledgeBaseEnabled,
      isGroupsEnabled,
    } = props

    let filteredKnowledgeBaseCategories: Props['categories'] = []
    let filteredGroupCategories: Props['categories'] = []

    if (isKnowledgeBaseEnabled) {
      filteredKnowledgeBaseCategories = categories.filter(categoryGroup => categoryGroup.type === 1)
    }

    if (isGroupsEnabled) {
      filteredGroupCategories = categories.filter(isGroup)
    }

    const filteredCommunityCategories = categories.filter(categoryGroup => categoryGroup.type !== 1 && !isGroup(categoryGroup))

    return {
      'knowledgeBase': filteredKnowledgeBaseCategories,
      'community': filteredCommunityCategories,
      'groups': filteredGroupCategories
    }
  }

  render(props: Props, state: State) {
    const {
      forum_id,
      error,
      onUpdate
    } = props
    const {publishIn} = state
    let className = 'article-creator__sidebar-form form-group'
    if (error) {
      className += ' error'
    }

    const grouppedCategories = this.groupCategories(this.props)

    let filteredCategories: Props['categories'] = grouppedCategories[state.publishIn]

    return (
      <div class={className}>
        <h2 class='article-creator__sidebar-form-heading'>Publish in *</h2>

        <div class='article-creator__sidebar-form-publish-in'>
          {grouppedCategories.community.length ? <div class='article-creator__sidebar-form-publish-in-radio-box'>
            <input
              id='communityCategory'
              class='article-creator__sidebar-form-publish-in-radio-box-input'
              type='radio'
              name='publishIn'
              onChange={this.handleRadioInputChange}
              value='community'
              checked={publishIn === 'community'}
            />
            <label class='article-creator__sidebar-form-publish-in-radio-box-label' for='communityCategory'>Community</label>
          </div> : null}

          {grouppedCategories.knowledgeBase.length ? <div class='article-creator__sidebar-form-publish-in-radio-box article-creator__sidebar-form-publish-in-radio-box--knowledgeBase'>
            <input
              id='knowledgeBaseCategory'
              class='article-creator__sidebar-form-publish-in-radio-box-input'
              type='radio'
              name='publishIn'
              onChange={this.handleRadioInputChange}
              value='knowledgeBase'
              checked={publishIn === 'knowledgeBase'}
            />
            <label class='article-creator__sidebar-form-publish-in-radio-box-label' for='knowledgeBaseCategory'>Knowledge Base</label>
          </div> : null}

          {grouppedCategories.groups.length ? <div class='article-creator__sidebar-form-publish-in-radio-box article-creator__sidebar-form-publish-in-radio-box--groups'>
            <input
              id='groupsCategory'
              class='article-creator__sidebar-form-publish-in-radio-box-input'
              type='radio'
              name='publishIn'
              onChange={this.handleRadioInputChange}
              value='groups'
              checked={publishIn === 'groups'}
            />
            <label class='article-creator__sidebar-form-publish-in-radio-box-label' for='groupsCategory'>Groups</label>
          </div> : null}
        </div>

        <CategorySelector
          categories={filteredCategories}
          selectedCategoryId={forum_id || undefined}
          onUpdate={(value: number) => onUpdate(value)}
        />
      </div>
    )
  }
}
